// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n@keyframes rowHighlight-1f0fb8ce {\n0% {\n        background-color: rgba(99, 102, 241, 0.2);\n}\n100% {\n        background-color: transparent;\n}\n}\n.animate-new-row[data-v-1f0fb8ce] {\n    animation: rowHighlight-1f0fb8ce 2.5s ease-out;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
